// extracted by mini-css-extract-plugin
module.exports = {"navItem":"nav_item_navItem__1-Gcq","link":"nav_item_link__8QBul"};